export default __webpack_public_path__ + "static/media/4.75c350a1.jpg";